module.exports = __webpack_public_path__ + "img/bg_09.12ef40ea.png";